export default __webpack_public_path__ + "static/media/raccoon-tree.ed54e4da.png";